import { render, staticRenderFns } from "./postsaleRD.vue?vue&type=template&id=6b8b70c6&"
import script from "./postsaleRD.vue?vue&type=script&lang=ts&"
export * from "./postsaleRD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports